import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Html from "./html";
import shared from "./shared";
import methodModel from "../../methods/methods";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import moment from "moment";

function Users() {
  const user = useSelector((state) => state.user);
  const history = useNavigate();

  // const [filters, setFilter] = useState({
  //   page: 1,
  //   count: 10,
  //   search: "",
  //   role: shared.role,
  //   startDate: moment().startOf("month").format("YYYY-MM-DD"),
  //   endDate: moment().format("YYYY-MM-DD"),
  //   dateFilterApplied: false,
  // });
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: "",
    role: shared.role,
    startDate: "",
    endDate: "",
    dateFilterApplied: false,
  });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(null);
  const [isDateSelecting, setIsDateSelecting] = useState(false);

  // const GetUsers = (p = {}) => {
  //   const filter = { ...filters, ...p };
  //   loader(true);
  //   ApiClient.get(shared.listApi, { ...filter, role: shared.role }).then(
  //     (res) => {
  //       if (res.success) {
  //         setData(res?.data);
  //         setTotal(res?.total);
  //       }
  //       loader(false);
  //     },
  //   );
  // };

  const GetUsers = (p = {}) => {
  const filter = { ...filters, ...p };

  const apiFilter = {
    ...filter,
    role: shared.role,
  };

  if (!apiFilter.dateFilterApplied) {
    delete apiFilter.startDate;
    delete apiFilter.endDate;
  }

  loader(true);

  ApiClient.get(shared.listApi, apiFilter).then(
    (res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res?.total);
      }
      loader(false);
    },
  );
};
  
  useEffect(() => {
    GetUsers();
  }, []);

  /** SORTING */
  const sortClass = (key) => {
    let cls = "fa-sort";

    if (filters.key === key && filters.sorder === "asc") cls = "fa-sort-up";
    else if (filters.key === key && filters.sorder === "desc")
      cls = "fa-sort-down";

    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = "asc";

    if (filters.key === key) {
      sorder = filters.sorder === "asc" ? "desc" : "asc";
    }

    const sortBy = `${key} ${sorder}`;

    setFilter({
      ...filters,
      sortBy,
      key,
      sorder,
    });
  };

  /** FILTER */
  const filter = (p = {}) => {
    setFilter({ ...filters, ...p, page: 1 });
    GetUsers({ ...filters, ...p, page: 1 });
  };

  /** CLEAR FILTER */
  // const clear = () => {
  //   setIsDateSelecting(false);
  //   const updated = {
  //     ...filters,
  //     page: 1,
  //     search: "",
  //     status: "",
  //     startDate: moment().startOf("month").format("YYYY-MM-DD"),
  //     endDate: moment().format("YYYY-MM-DD"),
  //     dateFilterApplied: false,
  //   };
  //   setFilter(updated);
  //   GetUsers(updated);
  // };


  const clear = () => {
  setIsDateSelecting(false);

  const updated = {
    ...filters,
    page: 1,
    search: "",
    status: "",
    startDate: "",
    endDate: "",
    dateFilterApplied: false,
  };

  setFilter(updated);
  GetUsers(updated);
};

  /** DELETE */
  const deleteItem = (id) => {
    methodModel.DeleteData(shared.deleteApi, id, shared.addTitle, GetUsers);
  };

  /** STATUS CHANGE */
  const statusChange = (itm) => {
    methodModel.StatusChange(shared.statusApi, itm, shared.addTitle, GetUsers);
  };

  /** PAGINATION */
  const pageChange = (page) => {
    setFilter({ ...filters, page });
    GetUsers({ ...filters, page });
  };

  const count = (count) => {
    setFilter({ ...filters, count });
    GetUsers({ ...filters, count });
  };

  /** STATUS FILTER */
  const changestatus = (value, name = "status") => {
    const updated = {
      ...filters,
      [name]: value,
      page: 1,
    };
    setFilter(updated);
    GetUsers(updated);
  };

  /** ROUTING */
  const edit = (id) => {
    history(`/${shared.url}/edit/${id}`);
  };

  const view = (id) => {
    history(`/${shared.url}/detail/${id}`);
  };

  return (
    <Html
      edit={edit}
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      deleteItem={deleteItem}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={false}
      data={data}
      total={total}
      statusChange={statusChange}
      changestatus={changestatus}
      isDateSelecting={isDateSelecting}
      setIsDateSelecting={setIsDateSelecting}
    />
  );
}

export default Users;
